<reporter-modal [show]="show"
                modalTitle="Create Companion Incident"
                [noFooter]="false"
                [displayCloseBtn]="true"
                (onClose)="cancel()">
  <div role="modal-body">
    <div class="form-group">
      <label for="lineOfBusiness">Line of Business</label>
      <select
        [class.placeholder]="!cloneLineOfBusiness"
        class="form-control required"
        id="lineOfBusiness"
        [(ngModel)]="cloneLineOfBusiness"
        (ngModelChange)="onLineOfBusinessChange($event)">
        <option [ngValue]="undefined"
                selected>Select a Line of Business
        </option>
        @for (lineOfBusiness of linesOfBusiness; track lineOfBusiness) {
          <option
            [ngValue]="lineOfBusiness.key">{{ lineOfBusiness.displayValue }}
          </option>
        }
      </select>
    </div>
    <div class="form-group">
      <label for="cloneQuestionnaireId">Questionnaire</label>
      <select
        [class.placeholder]="!cloneQuestionnaireId"
        class="form-control required"
        id="cloneQuestionnaireId"
        [(ngModel)]="cloneQuestionnaireId"
        [attr.disabled]="!cloneLineOfBusiness ? true : null">
        <option [ngValue]="undefined"
                selected>
          {{ cloneLineOfBusiness ? 'Select a Questionnaire' : 'Select a Line of Business first' }}
        </option>
        @for (questionnaire of questionnaires; track questionnaire) {
          <option
            [ngValue]="questionnaire.id">{{ questionnaire.displayName }}
          </option>
        }
      </select>
    </div>
  </div>

  <div role="modal-footer"
       class="d-flex justify-content-center w-100">
    <button type="button"
            class="btn btn-action"
            (click)="clone()"
            [disabled]="!cloneQuestionnaireId || !cloneLineOfBusiness">
      Create Companion Incident
    </button>
    <button type="button"
            class="btn btn-action ml-3"
            (click)="cancel()">
      Cancel
    </button>
  </div>
</reporter-modal>
